import * as React from 'react'

import Image from 'src/components/UI/Image/Image'
import LinkComponent from 'src/components/UI/LinkComponent/LinkComponent'
import { ArrowRightIcon } from 'src/components/UI/Icon/Icon'

import styles from './Highlight.module.scss'
import { getContentfulSrcSet } from 'src/utils/image'

type Props = {
  highlight: {
    fields: {
      title: string
      link: string
      image: {
        fields: any
      }
      buttonText: string
    }
  }
  fullWidth?: boolean
}

const Highlight = ({ highlight, fullWidth }: Props) => {
  const { title, link, image } = highlight.fields

  return (
    <LinkComponent to={link} className={styles.highlight}>
      <div className={styles.imageWrapper + ' image'}>
        <Image
          className={styles.image}
          srcSet={getContentfulSrcSet(image.fields.file.url)}
          alt={image.fields.title}
          critical={true}
          sizes={{
            mobile: '100vw',
            tablet: '40wv',
            desktop: '40vw',
          }}
        />
      </div>
      <div className={styles.background} />
      <div className={styles.content}>
        <div className={styles.cta}>
          <h3 className={styles.title}>{title}</h3>
          <ArrowRightIcon color="white" width={13} height={9} />
        </div>
      </div>
    </LinkComponent>
  )
}
export default Highlight
